import { Divider } from "../base";

interface Props {
  text: string;
}

const SectionHeader = ({ text }: Props) => {
  return (
    <div className="row">
      <div className="small-4 columns">
        <Divider />
      </div>
      <div className="small-4 columns">
        <h2 className="text-center">{text}</h2>
      </div>
      <div className="small-4 columns">
        <Divider />
      </div>
    </div>
  );
};

export { SectionHeader };
